// Bearbeitungsfortschritt eines Belegs auf einen Blick: eingegangen -> Rechnung erkannt -> Bankumsatz zugeordnet -> Kontierung geprueft -> fuer DATEV vorbereitet.
// Nur Darstellung: leitet die Schritte aus dem vorhandenen Belegstatus sowie den bereits vorhandenen Abfragen (Erkennung, Kontierung) ab; ein Schritt gilt nur dann als erledigt,
// wenn das System ihn tatsaechlich belegt.
import { useState, useEffect } from "react";
import THEME from "../../../../theme";
import { belegeApi, belegeStufe } from "../../../belege/belegeApi";

const BANK_AB = ["bankumsatz_zugeordnet", "an_datev_gesendet", "in_datev_bestaetigt"];
const DATEV_AB = ["an_datev_gesendet", "in_datev_bestaetigt"];

export default function BelegeFortschritt({ beleg }) {
  const [erkannt, setErkannt] = useState(false);
  const [kontiert, setKontiert] = useState(false);
  useEffect(() => {
    let aktiv = true;
    belegeApi.erkennung(beleg.id).then(e => { if (aktiv) setErkannt(!!e && (Array.isArray(e) ? e.length > 0 : Object.keys(e).length > 0)); }).catch(() => {});
    belegeApi.kontierung(beleg.id).then(k => { if (aktiv) setKontiert((k.bestaetigt || []).length > 0); }).catch(() => {});
    return () => { aktiv = false; };
  }, [beleg.id, beleg.status, beleg.aktualisiert_am]);
  const geprueft = beleg.status !== "eingegangen" && !["abgelehnt", "dublette", "rueckfrage"].includes(beleg.status);
  const schritte = [
    ["Eingegangen", true],
    ["Rechnung erkannt / geprüft", erkannt || geprueft],
    ["Bankumsatz zugeordnet", BANK_AB.includes(beleg.status)],
    ["Kontierung geprüft", kontiert],
    ["Für DATEV vorbereitet", DATEV_AB.includes(beleg.status)],
  ].slice(0, belegeStufe.erweitert ? 5 : 3);   // Stufe basis: Weg endet bei der Bankzuordnung
  if (["abgelehnt", "dublette", "rueckfrage"].includes(beleg.status)) return null;
  const naechster = schritte.findIndex(([, ok]) => !ok);
  return (
    <div role="list" aria-label="Bearbeitungsfortschritt" style={{ display: "flex", gap: 6, flexWrap: "wrap", margin: "10px 0" }}>
      {schritte.map(([name, ok], i) => (
        <span key={name} role="listitem" style={{ border: `1px solid ${ok ? THEME.colors.success : i === naechster ? THEME.colors.warning : THEME.colors.border}`, color: ok ? THEME.colors.success : i === naechster ? THEME.colors.warning : THEME.colors.textMuted,
          borderRadius: 999, padding: "2px 10px", fontSize: THEME.fontSize.sm, fontWeight: i === naechster ? 700 : 400 }}>
          {ok ? "✓" : i === naechster ? "→" : "○"} {name}
        </span>
      ))}
    </div>
  );
}
